export default "__VITE_ASSET__BvvoeqSj__"